<script lang="ts">
  import { Container, Row } from "sveltestrap";
  import Breadcrumb from "../../../Layout/Breadcrumb/Breadcrumb.svelte";
  import Bookmark from "../../../Layout/Breadcrumb/Bookmark.svelte";
  import Tips from "../Tips.svelte";
  import Title from "./Title.svelte";
  import { BoxLayout, Home,PageLayout,} from "../../../utils/Constant/Constant";
  let bodyData: string ="Add class='box-layout' attribute to get this layout. The boxed layout is helpful when working on large screens because it prevents the site from stretching very wide.";
  import { onMount } from "svelte";
  import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
  let ispreloader: boolean = false;
  onMount(() => {
    setTimeout(() => {
      ispreloader = true;
    }, 1000);
  });
</script>
{#if !ispreloader }
  <PreLodaer />
{/if}
<Container fluid>
  <div class="page-header">
    <Row>
      <Breadcrumb title={BoxLayout} home={Home} parent={PageLayout} />
      <Bookmark />
    </Row>
  </div>
</Container>
<Container fluid>
  <Row>
    <Tips discrpition={bodyData} headerprops="alert-heading" />
    <Title />
  </Row>
</Container>
